import { Redirect, Route, Switch } from 'react-router-dom';
import { registerBrowserRoutes } from '@zg-rentals/route-list';

import FrontPage from '../components/FrontPage';
import BillingPage from '../pages/BillingPage';
import InvoicePage from '../pages/InvoicePage';
import InvoicePaymentPage from '../pages/InvoicePaymentPage';
import AccountPaymentPage from '../pages/AccountPaymentPage';
import { NotFoundPage, defaultPaths as paths } from '@zg-rentals/rental-manager-env';
import { GuestPayLandingPage } from '../pages/GuestPay/GuestPayLandingPage';
import { GuestPaySelectInvoicesPage } from '../pages/GuestPay/GuestPayInvoicesPage';
import { GuestPayConfirmationPage } from '../pages/GuestPay/GuestPayConfirmationPage';
import { GuestPayPaymentDetailsPage } from '../pages/GuestPay/GuestPayPaymentDetails';
import { GuestPayNoInvoicesPage } from '../pages/GuestPay/GuestPayNoInvoicesPage';
import { GuestPaySubmitPayment } from '../pages/GuestPay/GuestPaySubmitPayment';

const ALLOW_PARAMS_REGEX = '([?].*)?([&].*)?';

export const manifest = {
  home: '/',
  billing: paths.billingPage,
  billingDue: paths.billingPage + '/' + paths.billingDue,
  billingPaid: paths.billingPage + '/' + paths.billingPaid,
  paymentSettings: paths.billingPage + '/' + paths.paymentSettings,
  invoicePage: paths.billingPage + '/' + paths.invoicePage + '/:invoiceId',
  invoicePaymentPage: paths.billingPage + '/' + paths.invoicePage + '/:invoiceId/payment',
  accountPaymentPage: paths.billingPage + '/account/:accountNumber',
  guestPayPage: paths.billingPage + '/guestPay',
  guestPayInvoicesPage: paths.billingPage + '/guestPay/invoices',
  guestPayConfirmationPage: paths.billingPage + '/guestPay/confirmation',
  guestPayPaymentDetailsPage: paths.billingPage + '/guestPay/paymentDetails',
  guestPaySubmitPaymentPage: paths.billingPage + '/guestPay/submitPayment',
  guestPayNoInvoicesPage: paths.billingPage + '/guestPay/noInvoices',
};

registerBrowserRoutes(manifest);

export function getRoutes() {
  return (
    <Switch>
      <Route exact component={FrontPage} path={manifest.home} />
      <Route component={BillingPage} exact={true} path={manifest.billingDue + ALLOW_PARAMS_REGEX} />
      <Route component={BillingPage} exact={true} path={manifest.billingPaid + ALLOW_PARAMS_REGEX} />
      <Route component={BillingPage} exact={true} path={manifest.paymentSettings + ALLOW_PARAMS_REGEX} />
      <Route component={InvoicePage} exact={true} path={manifest.invoicePage} />
      <Route component={InvoicePaymentPage} exact={true} path={manifest.invoicePaymentPage} />
      <Route component={AccountPaymentPage} exact={true} path={manifest.accountPaymentPage} />
      <Route component={GuestPayLandingPage} exact={true} path={manifest.guestPayPage + ALLOW_PARAMS_REGEX} />
      <Route
        component={GuestPaySelectInvoicesPage}
        exact={true}
        path={manifest.guestPayInvoicesPage + ALLOW_PARAMS_REGEX}
      />
      <Route
        component={GuestPayConfirmationPage}
        exact={true}
        path={manifest.guestPayConfirmationPage + ALLOW_PARAMS_REGEX}
      />
      <Route
        component={GuestPayPaymentDetailsPage}
        exact={true}
        path={manifest.guestPayPaymentDetailsPage + ALLOW_PARAMS_REGEX}
      />
      <Route
        component={GuestPaySubmitPayment}
        exact={true}
        path={manifest.guestPaySubmitPaymentPage + ALLOW_PARAMS_REGEX}
      />
      <Route
        component={GuestPayNoInvoicesPage}
        exact={true}
        path={manifest.guestPayNoInvoicesPage + ALLOW_PARAMS_REGEX}
      />
      <Route render={() => <Redirect to={manifest.billingDue} />} exact={true} path={manifest.billing} />
      <Route path="*" exact={true} component={NotFoundPage} />
    </Switch>
  );
}
